import React from 'react';
import {
  Box,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  useTheme,
} from '@mui/material';
import { Search, Clear } from '@mui/icons-material';

interface Props {
  value: string;
  onChange: (value: string) => void;
  isDebouncing: boolean;
  disabled?: boolean;
  placeholder?: string;
  maxWidth?: number;
}

function ItemsSearchInput({
  value,
  onChange,
  isDebouncing,
  disabled = false,
  placeholder = 'Search items by name...',
  maxWidth = 500,
}: Props) {
  const theme = useTheme();

  const handleClear = () => {
    onChange('');
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      handleClear();
    }
  };

  return (
    <Box sx={{ width: '100%', maxWidth }}>
      <TextField
        fullWidth
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search color="action" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {isDebouncing && (
                <CircularProgress size={20} color="primary" sx={{ mr: 1 }} />
              )}
              {value && !disabled && (
                <IconButton
                  size="small"
                  onClick={handleClear}
                  edge="end"
                  aria-label="clear search">
                  <Clear />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        sx={{
          // matches the search and filters on /customers
          '& .MuiOutlinedInput-root': {
            height: 44,
            borderRadius: '10px',
            fontSize: theme.typography.body2.fontSize,
            backgroundColor: theme.palette.background.paper,
          },
        }}
      />
    </Box>
  );
}

export default ItemsSearchInput;
